import React from 'react';
import {Link} from 'react-router';

class SettingsMenu extends React.Component {
  render() {
    var menuItems  = this.props.menu.map((item) => {
      return (
        <Link activeClassName={'current'} to={`/user/settings/${item.code}`} key={item.code}><i className={item.mobileIconClass}></i><span>{item.title}</span></Link>
      );
    });

    return (
      <div id="settings-menu">
        { menuItems }
      </div>
    );
  }
}

export default SettingsMenu;